const TOKEN_KEY = 'portal_token'
const MEMBER_KEY = 'portal_member'
const QUOTA_BALANCE_KEY = 'portal_quota_balance'

export function getToken() {
  return localStorage.getItem(TOKEN_KEY) || ''
}

export function setToken(token) {
  if (token) {
    localStorage.setItem(TOKEN_KEY, token)
  } else {
    localStorage.removeItem(TOKEN_KEY)
  }
}

export function getMember() {
  const raw = localStorage.getItem(MEMBER_KEY)
  if (!raw) return null
  try {
    return JSON.parse(raw)
  } catch (e) {
    return null
  }
}

export function setMember(member) {
  if (member) {
    localStorage.setItem(MEMBER_KEY, JSON.stringify(member))
  } else {
    localStorage.removeItem(MEMBER_KEY)
  }
}

export function isLoggedIn() {
  return !!getToken()
}

export function getCachedQuotaBalance() {
  const raw = sessionStorage.getItem(QUOTA_BALANCE_KEY)
  if (raw === null || raw === '') {
    return null
  }
  const value = Number(raw)
  return Number.isFinite(value) ? value : null
}

export function setCachedQuotaBalance(balance) {
  sessionStorage.setItem(QUOTA_BALANCE_KEY, String(Math.max(0, balance)))
}

export function clearCachedQuotaBalance() {
  sessionStorage.removeItem(QUOTA_BALANCE_KEY)
}

export function clearAuth() {
  setToken('')
  setMember(null)
  clearCachedQuotaBalance()
}
